module.exports = __webpack_public_path__ + "static/media/MASTERCARD.854505af.png";